<template>
  <div>
    <el-upload
      style="display: inline-block;vertical-align: top;margin: 0 8px 8px 0;"
      action=""
      :class="{ 'plus-hidden': fileList.length >= limit || status !== 'edit' }"
      :limit="limit"
      :accept="accept"
      list-type="picture-card"
      :show-file-list="false"
      :file-list="fileList"
      :http-request="handleChange">
      <i class="el-icon-plus"></i>
    </el-upload>
    <ul class="el-upload-list el-upload-list--picture-card">
      <li
        v-for="(item, index) in fileList"
        :key="index"
        tabindex="0"
        class="el-upload-list__item is-success">
        <img
          :src="item.url"
          class="el-upload-list__item-thumbnail">
        <span class="el-upload-list__item-actions">
          <span
            title="预览"
            class="el-upload-list__item-preview">
            <i
              class="el-icon-zoom-in"
              @click="handlePictureCardPreview(item)"></i>
          </span>
          <span
            v-if="status === 'edit'"
            title="删除"
            class="el-upload-list__item-delete">
            <i
              class="el-icon-delete"
              @click="handleRemove(index)"></i>
          </span>
          <!-- <span title="打码"
                v-if="status === 'edit' && mosaic"
                class="el-upload-list__item-delete">
            <i class="el-icon-edit"
               @click="addMosaic(item.url, index)"></i>
          </span> -->
          <span
            v-if="status === 'edit' && rolate"
            title="编辑"
            class="el-upload-list__item-delete">
            <i
              class="el-icon-edit"
              @click="editImage(item.url, index)"></i>
          </span>
        </span>
      </li>
    </ul>
    <img
      v-if="fileList.length === 0 && status !== 'edit'"
      :src="nopic">
    <div
      v-if="status === 'edit'"
      class="el-upload__tip"
      style="margin-top:0">只能上传{{ accept }}文件，最多{{ limit }}张，且每张不超过2M</div>
    <el-dialog
      :visible.sync="previewVisible"
      :width="dialogWidth"
      append-to-body>
      <img
        width="100%"
        :src="previewUrl">
    </el-dialog>
    <photo-mosaic-modal
      ref="mosaic"
      :callback="callback" />
    <tui-image-editor
      ref="tui"
      :callback="callback" />
  </div>
</template>

<script>
import PhotoMosaicModal from '../business/photo-mosaic-modal.vue'
import TuiImageEditor from './tui-image-editor.vue'
const nopic = require('@/assets/images/nopic.png')
export default {
  name: 'CustomUploadFile',
  components: { PhotoMosaicModal, TuiImageEditor },
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return []
      }
    },
    limit: {
      type: Number,
      default: 1000
    },
    accept: {
      type: String,
      default: 'image/*,.pdf'
    },
    status: {
      type: String,
      default: 'edit'
    },
    mosaic: {
      type: Boolean,
      default: false
    },
    rolate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      previewVisible: false,
      previewUrl: '',
      dialogWidth: '800px',
      nopic
    }
  },
  computed: {
    fileList: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    handleRemove(index) {
      this.fileList.splice(index, 1)
    },
    handleChange({ file }) {
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        this.$message.error('上传图片/PDF大小不能超过 2MB!')
        return
      }
      this.uploadFile(file)
    },
    addMosaic(image, index) {
      this.$refs.mosaic.init(image, index)
    },
    editImage(image, index) {
      this.$refs.tui.init(image, index)
    },
    callback(obj, index) {
      this.fileList.splice(index, 1, obj)
    },
    uploadFile(file) {
      const type = file.type
      const form = new FormData()
      this.$emit('update:loading', true)
      form.append('file', file)
      if (type === 'application/pdf') {
        this.$store.dispatch('common/uploadpdfandconver2image', {
          payload: form,
          success: (res) => {
            this.$emit('update:loading', false)
            const list = res.data.filepath.split(',')

            if (this.limit === 1) {
              this.fileList.push({
                url: res.data.viewUrl + list[0],
                filepath: list[0]
              })
            } else {
              list.forEach(item => {
                this.fileList.push({
                  url: res.data.viewUrl + item,
                  filepath: item
                })
              })
            }
          },
          fail: () => {
            this.$emit('update:loading', false)
          }
        })
      } else if (type.indexOf('image/') > -1) {
        this.$store.dispatch('common/uploadfile', {
          payload: form,
          success: (res) => {
            this.$emit('update:loading', false)
            this.fileList.push({
              url: res.data.viewUrl + res.data.filepath,
              filepath: res.data.filepath
            })
          },
          fail: () => {
            this.$emit('update:loading', false)
          }
        })
      }
    },
    handlePictureCardPreview(item) {
      this.previewUrl = item.url
      const image = new Image()
      image.onload = () => {
        this.dialogWidth = image.width + 'px'
        this.previewVisible = true
      }
      image.src = this.previewUrl
    }
  }
}
</script>
<style lang="stylus">
.plus-hidden {
  .el-upload.el-upload--picture-card {
    display: none;
  }
}
</style>
